import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from './slices/authSlice'
import mcqReducer from "./slices/mcqSlice";
import themeReducer from "./slices/themeSlice";
import timerReducer from "./slices/timer";
import answerReducer from './slices/answerSlice';
import { persistStore, persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};


const rootReducer = combineReducers({
  auth: authReducer,
  mcq: mcqReducer,
  theme: themeReducer,
  timer: timerReducer,
  answer: answerReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };


